module.exports = __webpack_public_path__ + "9f85624bf6c4cc2b9a4ad6be596232f2.png";